import styled from "styled-components";

const Container = styled.div`
    .container-main{
        background-color: white;
    }

    .userCompany button{
        background-color: white;
    }
`;

export default Container;